import React from 'react';

const BookmarkUnfilled = ({ ...props }) => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M0.5 20C0.5 9.23045 9.23045 0.5 20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20Z"
                fill="white"
            />
            <path
                d="M0.5 20C0.5 9.23045 9.23045 0.5 20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20Z"
                stroke="#222222"
            />
            <path
                d="M24.6 14.4V24.38L20.78 21.83L20 21.31L19.22 21.83L15.4 24.38V14.4H24.6ZM26 13H14V27L20 23L26 27V13Z"
                fill="#222222"
            />
        </svg>
    );
};

export default BookmarkUnfilled;
